module.exports = __webpack_public_path__ + "static/media/Daycare.8e87c201.jpg";